import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserByToken, setLoading, setFeatures } from './features/userSlice';
import { getItemWithExpiration } from '../utils/localStorageHelpers';
import featuresJson from '../utils/features.json';

import RoutesSetup from './routes';

import './App.css';

import i18n from './i18n';

function App() {
  const language = useSelector((state) => state.translation.language);
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  useEffect(() => {
    const token = getItemWithExpiration('findcv_user');

    if (token) {
      dispatch(fetchUserByToken(token));
    }
    else {
      dispatch(setLoading(false));
    }

  }, [dispatch]);

  // Extract and save features based on user's subscription plan
  useEffect(() => {
    if (user) {
      const basic = process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH;
      const basicYear = process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR;
      const sme = process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH;
      const smeYear = process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR;
      
      let planType = 0; // Default to free plan
      
      if (user?.activeSubscriptionPriceId === basic) planType = '1';
      else if (user?.activeSubscriptionPriceId === basicYear) planType = '2';
      else if (user?.activeSubscriptionPriceId === sme) planType = '3';
      else if (user?.activeSubscriptionPriceId === smeYear) planType = '4';
      
      // Extract features based on subscription plan
      let planFeatures = null;
      
      if (planType === '1') {
          // Monthly basic plan
          planFeatures = featuresJson.monthly.basic;
      } else if (planType === '2') {
          // Yearly (semiannual) basic plan
          planFeatures = featuresJson.semiannual.basic;
      } else if (planType === '3') {
          // Monthly SME plan
          planFeatures = featuresJson.monthly.sme;
      } else if (planType === '4') {
          // Yearly (semiannual) SME plan
          planFeatures = featuresJson.semiannual.sme;
      } else {
          // Free plan (default)
          planFeatures = featuresJson.monthly.free;
      }
      
      // Save features to Redux store
      if (planFeatures) {
          dispatch(setFeatures(planFeatures));
      }
    }
  }, [user, dispatch]);

  return (
    <RoutesSetup />
  );
}

export default App;
